module.exports = __webpack_public_path__ + "media/components/shared/static/linkedin-ed000d16891a658cf7b024a0244d5421.svg";